module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/router-2-a86961e626b71675c204f7e1c95ea901.svg";